import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const JoystickIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M9 4.73244C9.5978 4.38663 10 3.74028 10 3C10 1.89543 9.10457 1 8 1C6.89543 1 6 1.89543 6 3C6 3.74028 6.4022 4.38663 7 4.73244C7.01543 4.74136 7.03099 4.75009 7.04668 4.75861C7.33007 4.91256 7.65482 5 8 5C8.36429 5 8.70583 4.90261 9 4.73244Z"
		/>
		<path
			fill="currentColor"
			d="M7 5.29198V9.125C7 9.42097 9 9.42097 9 9.125V5.29198C8.69377 5.42578 8.35555 5.5 8 5.5C7.64445 5.5 7.30623 5.42578 7 5.29198Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 7L2.55279 8.72361C2.214 8.893 2 9.23926 2 9.61803V11.382C2 11.7607 2.214 12.107 2.55279 12.2764L7.55279 14.7764C7.83431 14.9172 8.16569 14.9172 8.44721 14.7764L13.4472 12.2764C13.786 12.107 14 11.7607 14 11.382V9.61803C14 9.23926 13.786 8.893 13.4472 8.72361L10 7V9.12499C10 9.7829 9.46177 10.0656 9.36653 10.1139C9.1912 10.2028 9.00867 10.2474 8.88108 10.2726C8.60766 10.3265 8.28763 10.347 8 10.347C7.71237 10.347 7.39234 10.3265 7.11892 10.2726C6.99133 10.2474 6.8088 10.2028 6.63347 10.1139C6.53823 10.0656 6 9.7829 6 9.12499V7ZM13 10.8528C13 11.0043 12.9144 11.1428 12.7789 11.2106L8.28944 13.4553C8.15646 13.5218 8 13.4251 8 13.2764V12.7472C8 12.5957 8.0856 12.4572 8.22111 12.3895L12.7106 10.1447C12.8435 10.0782 13 10.1749 13 10.3236V10.8528Z"
		/>
	</svg>
))
